// extracted by mini-css-extract-plugin
module.exports = {"backImg":"skipLinks_backImg__vGsjl","skipLinks":"skipLinks_skipLinks__z__Ds"};